import { Molecule } from 'AppReact';
import styled from 'styled-components';
import device from 'components/atoms/utils/device';
import { CheckboxSvg } from 'components/icons';
import { Icon, Title } from './atoms';

const template = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;

  cursor: pointer;

  width: 100%;
  min-width: 100%;

  @media ${device.tablet} {
    width: 50%;
    min-width: 50%;
  }

  @media ${device.laptopL} {
    width: 33%;
    min-width: 33%;
  }

  @media ${device.desktop} {
    width: 25%;
    min-width: 25%;
  }

`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Checkbox',
      displayValue: ({ child }) => CheckboxSvg({ checked: child.active })
    },
    {
      component: Title,
      name: 'Title',
      displayValue: ({ child }) => child.name,
      displayState: ({ child }) => ({ selected: child.active }),
    },
  ],
})